import styles from "../../styles/common/ModalForm.module.scss";
import creditLineStyles from "../../styles/views/CreditLineDetail.module.scss";

import React, {useCallback, useState} from "react";
import clsx from "clsx";
import { ArrowDownLeft } from 'lucide-react';

import {HomeDrawCreditModalViewList} from "../../utils";
import {AvailableBalance} from "../../utils/creditService";

import Modal from "../common/Modal";

interface HomeDrawCreditModalProps {
  creditLine: AvailableBalance
}

function HomeDrawCreditModal({creditLine}: HomeDrawCreditModalProps) {
  const [currentView, setCurrentView] = useState(0)
  const [homeDrawCreditModalIsOpen, setHomeDrawCreditModalIsOpen] = useState(false)

  const handleToggleModal = useCallback(() => {
    setHomeDrawCreditModalIsOpen(homeDrawCreditModalIsOpen => !homeDrawCreditModalIsOpen)
  }, [setHomeDrawCreditModalIsOpen])

  const handleCloseModal = useCallback(() => {
    setHomeDrawCreditModalIsOpen(false)
    setCurrentView(0)
  }, [setHomeDrawCreditModalIsOpen])

  const handleBack = () => {
    setCurrentView(0)
  }

  const views = HomeDrawCreditModalViewList({ onCloseModal: handleCloseModal, setCurrentView, handleBack, creditLine})

  return (
    <>
      <button 
        className={clsx(creditLineStyles.actionButton, creditLineStyles.primary)}
        onClick={handleToggleModal}
        disabled={creditLine.available <= 0}
      >
        <ArrowDownLeft className={creditLineStyles.buttonIcon} />
        <span>Draw Credit</span>
      </button>

      <Modal
        extraClassName={clsx(styles.cModalForm, "c-modal-form", "c-home-draw-credit-modal", `view-${views[currentView].id}`)}
        isModalOpen={homeDrawCreditModalIsOpen}
        onCloseModal={handleCloseModal}
        hideModalHeader
        modalSize={currentView === 0? "md" : "sm"}
      >
        {React.cloneElement(views[currentView].component, { creditLine })}

      </Modal>
    </>
  );
}

export default HomeDrawCreditModal;